import React from "react";
import { ShieldCheck, Award, MapPin, Stethoscope, Dumbbell } from "lucide-react";

const items = [
  { icon: Award, label: "10+ Yrs Master Trainer" },
  { icon: ShieldCheck, label: "Weight Management Specialist" },
  { icon: Stethoscope, label: "Corrective Exercise Specialist" },
  { icon: Dumbbell, label: "Functional Strength" },
  { icon: MapPin, label: "Dubai Mall · Zabeel" },
];

export const TrustStrip = () => {
  return (
    <section
      data-testid="trust-strip"
      className="relative border-y border-white/5 bg-black/40 backdrop-blur-xl"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6">
        <div className="flex flex-wrap items-center justify-center lg:justify-between gap-x-10 gap-y-4">
          {items.map((it) => (
            <div key={it.label} className="flex items-center gap-2 text-zinc-400 text-sm">
              <it.icon className="w-4 h-4 text-[#00E5FF]" />
              <span className="uppercase tracking-[0.18em] text-xs font-medium">{it.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustStrip;
